import { render, staticRenderFns } from "./StatusIcon.vue?vue&type=template&id=35a9be16"
import script from "./StatusIcon.vue?vue&type=script&lang=ts"
export * from "./StatusIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports